import React from "react";
import type { ModalProaceDimensionsType } from "../../../utils/modalConstants";
import * as Modal from "../../../../../../common-deprecated/styles/v2/toyota/globals/Modal";
import Icon from "../../../../../../common-deprecated/styles/v2/toyota/globals/Icon";
import * as Flex from "../../../../../../common-deprecated/styles/v2/toyota/globals/Flex";
import * as Image from "../../../../../../common-deprecated/styles/v2/toyota/globals/Image";
import * as Table from "../../../../../../common-deprecated/styles/v2/toyota/globals/Table";
import ModalBaseView from "../../../../../../common-deprecated/components/modals/aem/ModalBaseView";
import { CommonLabel, useCommonLabel } from "../../../../../../common-deprecated/utils/commonLabels";
import IconWrapper from "../../../../../../common-deprecated/styles/v2/toyota/globals/IconWrapper";
import type { ModalViewType } from "../../../../../../common-deprecated/types/CommonTypes";

const ProaceDimensionsModal = (props: ModalViewType<ModalProaceDimensionsType>): JSX.Element => {
    const { show, close, modalSettings } = props;
    const { dimensions } = modalSettings;

    const closeLabel = useCommonLabel("close");

    return (
        <ModalBaseView modalIdType={modalSettings.type} onClose={close} show={show} size="md">
            <Modal.Header>
                <Modal.Title>
                    <CommonLabel label="dimensions" />
                </Modal.Title>
                <Modal.Button type="button" aria-label={closeLabel} onClick={close}>
                    <IconWrapper aria-hidden="true">
                        <Icon variant="close" />
                    </IconWrapper>
                </Modal.Button>
            </Modal.Header>
            <Modal.Body>
                <Flex.Row>
                    <Flex.Col width={{ xs: 1, md: 1 / 2 }}>
                        <Table.Base>
                            {dimensions.capacity.map(({ unit, value, id, name }) => (
                                <Table.TR key={id}>
                                    <Table.TD>{name}</Table.TD>
                                    <Table.TD textAlign="right">
                                        {value}
                                        {unit}
                                    </Table.TD>
                                </Table.TR>
                            ))}
                        </Table.Base>
                    </Flex.Col>
                    <Flex.Col width={{ xs: 1, md: 1 / 2 }}>
                        {!!dimensions.dimensions.length && (
                            <Table.Base>
                                {dimensions.dimensions.map(({ value, id, name }) => (
                                    <Table.TR key={id}>
                                        <Table.TD>{name}</Table.TD>
                                        <Table.TD textAlign="right">{value}</Table.TD>
                                    </Table.TR>
                                ))}
                            </Table.Base>
                        )}

                        {!dimensions.dimensions.length && (
                            <Image.ImageFluid
                                src={dimensions.bootImage.default}
                                srcSet={dimensions.bootImage.set}
                                sizes=""
                                draggable={false}
                            />
                        )}
                    </Flex.Col>
                </Flex.Row>
            </Modal.Body>
        </ModalBaseView>
    );
};

export default ProaceDimensionsModal;
